import { render, staticRenderFns } from "./StatInfoCard.vue?vue&type=template&id=ea0f504c&scoped=true"
import script from "./StatInfoCard.vue?vue&type=script&lang=js"
export * from "./StatInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0f504c",
  null
  
)

export default component.exports